import { apiHelper } from './api_helper';

export const EMAIL_TEMPLATE_ENDPOIT ='email-template';
export const emailTemplateApi = {
    SelectByCoSo: (dm_coso_id) => apiHelper.get(`${EMAIL_TEMPLATE_ENDPOIT}/coso/${dm_coso_id}`),
    Detail: (id) => apiHelper.get(`${EMAIL_TEMPLATE_ENDPOIT}/${id}`),
    Insert : (data) => apiHelper.post(EMAIL_TEMPLATE_ENDPOIT,data),
    Update: (data)=> apiHelper.put(EMAIL_TEMPLATE_ENDPOIT, data),
    Delete: (id)=> apiHelper.delete(`${EMAIL_TEMPLATE_ENDPOIT}/${id}`)
}